import React, { memo } from "react";
import { validators } from "investira.sdk";
import { Stack, Typography, Card, Tooltip, Icon } from "investira.react.components";
import { formats } from "investira.sdk";

const TreynorCard = memo(props => {
  const {
    value = 0,
    label = "Sharpe",
    tooltip
  } = props;

  const palette = pValue => {
    return {
      color: "text.primary"
    };
  };

  return <Card sx={{
    flex: 1,
    display: "flex",
    minHeight: 0,
    ...palette(value)
  }}>
      <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="caption" color="inherit" sx={{
          fontWeight: 500
        }}>
            {label}
          </Typography>
          {tooltip && <Tooltip title={tooltip}>
              <span>
                <Icon size={16} color={"inherit"} iconName="information" />
              </span>
            </Tooltip>}
        </Stack>
        <Stack direction="column" justifyContent="flex-end">
          <Stack>
            <Typography variant={{
            xs: "h6",
            xl: "h5"
          }} color="inherit">
              <b>
                {!validators.isNull(value) ? formats.formatNumber(value, 3, true) : `---`}
              </b>
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Card>;
});

export default TreynorCard;
